// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__E627E","info":"UpdateTermsInfo_info__38d3i"};